import { render } from "./ProfileList.vue?vue&type=template&id=6d135198&scoped=true&ts=true"
import script from "./ProfileList.vue?vue&type=script&lang=ts"
export * from "./ProfileList.vue?vue&type=script&lang=ts"

import "./ProfileList.vue?vue&type=style&index=0&id=6d135198&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d135198"]])

export default __exports__